<script setup lang="ts">
import HeaderViewBannerGrid from '~/components/utils/HeaderViewBannerGrid.vue'
import AuSkeletonWrapper from '~/components/ui/AuSkeletonWrapper.vue'
import AuSkeleton from '~/components/ui/AuSkeleton.vue'
</script>

<template>
  <AuSkeletonWrapper>
    <HeaderViewBannerGrid
      class="size-full bg-(--theme-60) py-24 md:py-32"
    >
      <div class="grid-in-header-info">
        <AuSkeleton height="4rem" />
        <AuSkeleton
          height="1.5rem"
          width="80%"
        />
        <AuSkeleton
          height="1.5rem"
          width="70%"
        />
        <AuSkeleton
          height="1.5rem"
          width="80%"
        />
        <AuSkeleton
          height="1.5rem"
          width="65%"
        />
        <AuSkeleton
          height="1.5rem"
          width="70%"
        />
      </div>
    </HeaderViewBannerGrid>
  </AuSkeletonWrapper>

  <!-- these sections are a copy of the skeleton in Header1To4 -->
  <div class="space-y-20 pb-20">
    <section
      v-for="index in 2"
      :key="index"
    >
      <AuSkeletonWrapper class="max-w-screen-au mx-auto space-y-4 px-4 sm:px-8">
        <AuSkeleton
          height="36px"
          width="120px"
        />
        <ul class="xs:grid-cols-2 grid grid-cols-1 gap-8 md:grid-cols-3 lg:grid-cols-4">
          <AuSkeleton
            v-for="i in 4"
            :key="i"
            height="auto"
            class="aspect-video"
            border-radius="0px"
          />
        </ul>
      </AuSkeletonWrapper>
    </section>
  </div>
</template>
